import { FC, useState } from 'react';
import { Button, Checkbox, Group, Modal, Text, Title } from '@logz-ui/styleguide';
import { useNewApplicationState } from '../../../hooks/new-application-state.hook';
import { useIsNewAppEnabled } from 'ui/hooks/is-new-application-enabled.hook';

export const NewAppActiveModal: FC = () => {
  const { data: newAppState } = useNewApplicationState.query();
  const { isNewAppEnabled } = useIsNewAppEnabled();

  const [isOpen, setIsOpen] = useState(isNewAppEnabled && !newAppState?.shouldHideNavigationModal);

  const [shouldHideNextModal, setShouldHideNextModal] = useState<boolean>(false);
  const { mutate } = useNewApplicationState.mutation();

  const handleShowAgainCheckbox = () => {
    if (shouldHideNextModal) {
      mutate({ shouldHideNavigationModal: true });
    }
  };

  const onConfirm = () => {
    handleShowAgainCheckbox();
    setIsOpen(false);
  };

  return (
    <Modal open={Boolean(isOpen)} dontCloseOnOverlayClick noCloseButton>
      <Modal.Header>
        <Title>You’re viewing Logz.io’s previous experience</Title>
      </Modal.Header>
      <Modal.Body>
        <Group vertical gap={4}>
          <Text>
            This link is part of the previous Logz.io experience. This is a temporary view to allow you to view and
            interact with it. Close the tab to return to Open 360 AI.
          </Text>
        </Group>
      </Modal.Body>
      <Modal.Footer justifyContent={'space-between'}>
        <Checkbox checked={shouldHideNextModal} onChange={setShouldHideNextModal} label={'Don’t ask me again'} />
        <Button onClick={onConfirm}>Continue</Button>
      </Modal.Footer>
    </Modal>
  );
};
